import { render, staticRenderFns } from "./MotdTool.vue?vue&type=template&id=721d57cb&scoped=true&"
import script from "./MotdTool.vue?vue&type=script&lang=js&"
export * from "./MotdTool.vue?vue&type=script&lang=js&"
import style0 from "./MotdTool.vue?vue&type=style&index=0&id=721d57cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d57cb",
  null
  
)

export default component.exports